import { useState } from 'react'
import { useCustomEvent } from '../useCustomEvent'
import { AppSpaceSidebarMenuEvents } from './events'
import { ToggleMenuEvent } from './types'

const useSidebarMenu = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  useCustomEvent(AppSpaceSidebarMenuEvents.TOGGLE_MENU, (event: ToggleMenuEvent) => {
    setIsOpenMenu(event.isOpen)
  })

  return { isOpenMenu }
}

export default useSidebarMenu
